<!-- A slim footer, so both RIC tools have the same shape.
     Deliberately lighter than the BGO Tool's: that one is client-facing and
     carries contact details and two logos; this app is internal and only needs
     to say what it is. -->
<footer class="mt-12 border-t border-base-300">
  <div
    class="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-5 text-xs opacity-50"
  >
    <span class="flex items-center gap-2">
      <img src="/RIC-Icon.png" alt="" class="h-4 w-4 object-contain" />
      RIC Dev Tool — internal use
    </span>
    <span class="flex items-center gap-3">
      <a
        href="http://www.ricgroup.net/"
        target="_blank"
        rel="noopener noreferrer"
        class="hover:opacity-100 hover:underline"
      >
        www.ricgroup.net
      </a>
      <span class="opacity-40">·</span>
      <span class="flex items-center gap-1">
        Created
        <!-- rel="noopener noreferrer" is not optional alongside target="_blank":
             without it the opened tab can reach back through window.opener. -->
        <a
          href="https://rdavi.dev"
          target="_blank"
          rel="noopener noreferrer"
          class="font-medium text-primary hover:underline"
        >
          rdavi.dev
        </a>
      </span>
    </span>
  </div>
</footer>
